/*
  Geminii Rogue Pricing Model
  ============================
  Base prices in USD. CurrencyContext converts to visitor's local currency.

  TWO paths to buy:
  1. All Rogue Package (flat monthly, all 8 modules) — the hero offer
  2. Per-module à la carte (per user/month) — for businesses needing only specific modules

  INTRO OFFER: 50% off first 3 months on all plans.

  TIER DIFFERENTIATION:
  - Starter (1-5 users): Core features, email support (48h), mobile app, basic analytics
  - Growth (6-15 users): + White-label, API access, priority support (4h), advanced analytics, custom roles
  - Business (16-50 users): + Dedicated CSM, custom domain, 1h SLA, SSO, audit logs, onboarding
  - Enterprise (50+): Custom pricing, SLA guarantees, dedicated infrastructure
*/

// === ALL ROGUE PACKAGE (flat monthly, all 8 modules included) ===
export const PACKAGES = {
  starter: { name: "Starter", users: "1–5 users", price: 49, intro: 25 },
  growth:  { name: "Growth",  users: "6–15 users", price: 99, intro: 49 },
  business:{ name: "Business",users: "16–50 users",price: 199,intro: 99 },
};

// Additional users beyond package limit
export const EXTRA_USER_PRICE = { starter: 9, growth: 7, business: 5 };

// === PER-MODULE À LA CARTE (per user/month) ===
export const MODULE_PRICES = {
  starter: 9,
  growth: 15,
  business: 24,
};

// === CEREBRUM AI ADD-ON ===
export const CEREBRUM_PRICES = {
  starter: { price: 19, intro: 10 },
  growth:  { price: 39, intro: 20 },
  business:{ price: 69, intro: 35 },
};

// === TIER FEATURES ===
export const TIER_FEATURES = {
  starter: {
    label: "Starter",
    userRange: "1–5 users",
    included: [
      "All core module features",
      "Mobile app access",
      "Basic analytics dashboard",
      "Email support (48h response)",
      "5 GB file storage",
      "Community knowledge base",
    ],
    excluded: [
      "White-label / custom branding",
      "API access",
      "Advanced analytics",
      "Custom roles & permissions",
      "Priority support",
      "SSO / audit logs",
    ],
  },
  growth: {
    label: "Growth",
    userRange: "6–15 users",
    popular: true,
    included: [
      "Everything in Starter, plus:",
      "White-label option (your logo, your brand)",
      "API access for integrations",
      "Advanced analytics & custom reports",
      "Custom roles & granular permissions",
      "Priority support (4h response SLA)",
      "25 GB file storage",
      "Team performance dashboards",
    ],
    excluded: [
      "Dedicated CSM",
      "Custom domain",
      "SSO / SAML",
      "Audit logs",
      "Onboarding assistance",
    ],
  },
  business: {
    label: "Business",
    userRange: "16–50 users",
    included: [
      "Everything in Growth, plus:",
      "Dedicated customer success manager",
      "Custom domain (yourcompany.rogue.app)",
      "SSO / SAML authentication",
      "Full audit logs & compliance",
      "1h support SLA",
      "White-glove onboarding",
      "100 GB file storage",
      "Priority feature requests",
    ],
    excluded: [],
  },
};

export const INTRO_DISCOUNT = 0.5; // 50% off
export const INTRO_MONTHS = 3;
